export const INTRO_SLIDER_ITEMS = [
    'intro-cybersecurity-base',
    'intro-cybersecurity-improve',
    'intro-career-start',
    'intro-management',
    'intro-safer-world',
];
